import configs from '@/config'
// Sentry
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import { createSentry } from '@ahaslides-product/frontend-toolkit'

export { isExpectedTransientResponse } from '@ahaslides-product/frontend-toolkit'

const ignoreErrors = [
  'zaloJSV2 is not defined',
  'Can\'t find variable: zaloJSV2',
  'ResizeObserver loop limit exceeded',
  'Cannot read property \'getReadModeConfig\' of undefined',
  'Cannot read property \'getReadModeRender\' of undefined',
  'Cannot read property \'getReadModeExtract\' of undefined',
  'UnhandledRejection: Non-Error promise rejection captured with value: Object Not Found Matching Id:2',
]

const dropExpectedErrors = (event, hint) => {
  const error = hint?.originalException
  const name = error?.name
  const message = error?.message || ''

  // Safari's opaque network-layer failure for a fetch/resource load (our request
  // layer appends the host): a client connectivity or CDN drop, never an app
  // fault, flooding Sentry from mobile audiences. Anchored to the start so a
  // genuine app error that merely contains the phrase still reports.
  if (name === 'TypeError' && message.startsWith('Load failed')) {
    return null
  }

  // The Chromium sibling of the Safari case above: an unhandledrejection from
  // a failed fetch (CDN/network drop), raised via src/instrument/fetch.ts —
  // never an app fault. Same anchoring rationale.
  if (name === 'TypeError' && message.startsWith('Failed to fetch')) {
    return null
  }

  // Home.vue's validateAcessCode() throws this itself when the presentation
  // lookup resolves with an empty body — the audience typed a wrong/expired
  // access code, the single expected outcome of that form. Exact match on
  // both fields: a plain `Error` is otherwise a catch-all type, so anchoring
  // to this literal message keeps any other Error still reporting.
  if (name === 'Error' && message === 'No presentation found') {
    return null
  }

  return event
}

const sentry = createSentry({
  Sentry,
  Vue,
  config: {
    enabled: configs.isSentryEnabled,
    dsn: configs.sentry,
    release: configs.sentryRelease,
    environment: configs.env,
    tracesSampleRate: 0,
    propagateTraceparent: true,
    ignoreErrors,
    denyUrls: [
      /analytics\.tiktok\.com/i,
    ],
  },
  appRules: [dropExpectedErrors],
})

export const { logInfo, logWarn, getTraceId } = sentry

export default {
  init: sentry.init,
  captureException: sentry.captureException,
  addBreadcrumb: sentry.addBreadcrumb,
  info: sentry.logInfo,
  warn: sentry.logWarn,
  setTags: sentry.setTags,
}
